// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IMccDto
 */
export interface IMccDto {
    /**
     * 
     * @type {number}
     * @memberof IMccDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IMccDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof IMccDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IMccDto interface.
 */
export function instanceOfIMccDto(value: object): value is IMccDto {
    return true;
}

export function IMccDtoFromJSON(json: any): IMccDto {
    return IMccDtoFromJSONTyped(json, false);
}

export function IMccDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IMccDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IMccDtoToJSON(json: any): IMccDto {
    return IMccDtoToJSONTyped(json, false);
}

export function IMccDtoToJSONTyped(value?: IMccDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'description': value['description'],
    };
}

